<div class="flex w-full flex-col text-default">
  <div class="mb-2 flex items-center">
    <mat-icon
      class="icon-size-3 mr-1"
      svgIcon="heroicons_solid:link"
    ></mat-icon>
    <span class="text-sm font-medium">{{ messages.sectionTitle | transloco }}</span>
  </div>

  <div class="flex items-center justify-between">
    <svc-slide-toggle
      class="mr-4"
      svcTestId="outlook-integration__toggle--connection"
      [checked]="toggleChecked()"
      [disabled]="toggleDisabled()"
      (change)="onToggleChange($event)"
    ></svc-slide-toggle>
    <div class="flex-auto">
      <div class="text-xs font-medium leading-none">{{ messages.toggleLabel | transloco }}</div>
    </div>
    @if (processing()) {
      <mat-progress-spinner
        class="ml-2 shrink-0"
        diameter="16"
        mode="indeterminate"
      ></mat-progress-spinner>
    }
  </div>

  @if (expiredNotice()) {
    <div
      class="mt-2 text-xs text-warn"
      svcTestId="outlook-integration__alert--expired"
    >
      {{ messages.expired | transloco }}
    </div>
  }
</div>
